import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, DatePicker, Radio, Card, Input, Popconfirm, Checkbox, Empty } from 'antd';
import React, { useEffect, Suspense, useState } from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { DownloadOutlined, PrinterOutlined } from '@ant-design/icons';
import axios from 'axios';

// import { Presentation, Slide, Text, Shape, Image, render } from "react-pptx";
const PreviewPdfModal = (props) => {
    // const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const handleDownload = () => {
        // console.log(props.file);
        // console.log(props.file.file_id);
        axios
            .get('/cramSchool/api/media/classify_structure_type_file_download', {
                responseType: 'blob',
                params: {
                    file_id: props.file.file_id
                }
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${props.file.file_client_name}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    const handlePrint = () => {
        axios
            .get('/cramSchool/api/media/classify_structure_type_file_download', {
                responseType: 'blob',
                params: {
                    file_id: props.file.file_id
                }
            })
            .then((response) => {
                var blob = new Blob([response.data], { type: 'application/pdf' }); //this make the magic
                var blobURL = URL.createObjectURL(blob);

                let iframe = document.createElement('iframe'); //load content in an iframe to print later
                document.body.appendChild(iframe);

                iframe.style.display = 'none';
                iframe.src = blobURL;
                iframe.onload = function () {
                    setTimeout(function () {
                        iframe.focus();
                        iframe.contentWindow.print();
                    }, 1);
                };
            })
    }
    return (
        <Modal
            open={props.open}
            // onOk={hideModal}
            onCancel={e => props.setOpen(false)}
            footer={false}
            width={800}
            style={{ padding: '20px' }}
            centered
        >
            <Row justify={'end'} style={{ paddingRight: '20px' }} gutter={[8, 16]}>
                <Col style={{ paddingTop: '10px' }}>
                    <Button type='primary' style={{ display: "inline-flex", alignItems: "center" }} icon={<PrinterOutlined />}
                        // onClick={e => window.open(`${axios.defaults.baseURL}/cramSchool/api/media/classify_structure_type_file_download?file_id=${props.file_id}`)}
                        // onClick={handleDownload}
                        onClick={handlePrint}
                    >列印</Button>
                </Col>
                <Col style={{ paddingRight: '40px', paddingTop: '10px' }}>
                    <Button type='primary' style={{ display: "inline-flex", alignItems: "center" }} icon={<DownloadOutlined />}
                        // onClick={e => window.open(`${axios.defaults.baseURL}/cramSchool/api/media/classify_structure_type_file_download?file_id=${props.file_id}`)}
                        onClick={handleDownload}
                    >檔案下載</Button>
                </Col>
                <Col span={24}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.15.349/build/pdf.worker.js">
                        <Viewer
                            fileUrl={`${props?.file_url}`}
                        // plugins={[
                        //     defaultLayoutPluginInstance,
                        // ]}
                        />
                    </Worker>
                </Col>
            </Row>
        </Modal>
    )
}
export default PreviewPdfModal;